// deps
import React, { ReactElement, ReactNode, memo, useMemo } from "react";

// styles
import { TOAST_CONTAINER_CLASSNAME, ToastContainer } from "./styles";

// dls
import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";
import { Toast } from "@swiggy-private/dls-web-recipe-food-web/dist/components/Toast";
import { IToastProps } from "@swiggy-private/dls-web-recipe-food-web/dist/components/Toast/types";
import { default as Warning } from "@swiggy-private/dls-web-icons/dist/web/generic/warningFilled/24";

export interface GenericCartToastProps {
    toastData: IToastProps;
}

function GenericCartToast({ toastData }: GenericCartToastProps): ReactElement | null {
    const defaultIcon: ReactNode = useMemo(() => {
        return <GenericIcon Icon={Warning} strokeColor="warning" fillColor="warning" />;
    }, []);

    return (
        <ToastContainer>
            <Toast autoDismiss leftAsset={defaultIcon} {...toastData} containerClass={TOAST_CONTAINER_CLASSNAME} />
        </ToastContainer>
    );
}

export default memo(GenericCartToast);
